import { RiskMatrix } from '@models/clients/clients.details/compliance/riskMatrix';

export class RiskMatrixPanelController {
    public isOpen: boolean = false;
    public isEdit: boolean = false;
    public riskMatrix: RiskMatrix = {};
    public errorMessage: string = '';
    public onSave: (riskMatrix: RiskMatrix) => void;
    public onClose: () => void;
    public onDelete: (riskMatrix: RiskMatrix) => void;

    /** @ngInject */
    constructor() {}

    public $onInit(): void {
        this.resetForm();
    }

    public open(riskMatrix?: RiskMatrix): void {
        this.isOpen = true;
        this.isEdit = !!riskMatrix;
        this.errorMessage = ''; // Clear any previous errors
        
        // Prevent body scroll
        document.body.classList.add('slide-out-panel-open');
        
        if (riskMatrix && typeof riskMatrix === 'object') {
            this.riskMatrix = { ...riskMatrix };
        } else {
            this.resetForm();
        }
    }

    public close(): void {
        this.isOpen = false;
        this.errorMessage = ''; // Clear errors when closing
        
        // Restore body scroll
        document.body.classList.remove('slide-out-panel-open');
        
        if (this.onClose) {
            this.onClose();
        }
    }

    public save(): void {
        // TODO: Add more validation here
        console.log('save', this.riskMatrix);
        
        // Clear previous error messages
        this.errorMessage = '';
        
        // Validate required fields
        if (!this.riskMatrix || !this.riskMatrix.riskRating) {
            this.errorMessage = 'Risk rating is required. Please select a risk rating before saving.';
            console.error('Risk rating is required');
            return; // Don't save or close the panel
        }

        // Ensure riskMatrix is properly initialized
        if (!this.riskMatrix) {
            this.riskMatrix = {};
        }

        // Add timestamps
        if (!this.riskMatrix.dateCreated) {
            this.riskMatrix.dateCreated = new Date();
        }
        this.riskMatrix.dateModified = new Date();

        if (this.onSave) {
            (this.onSave as any)({ riskMatrix: { ...this.riskMatrix } });
        }
        
        this.close();
    }



    public delete(): void {
        if (this.riskMatrix && this.riskMatrix.id) {
            if (this.onDelete) {
                (this.onDelete as any)({ riskMatrix: { ...this.riskMatrix } });
            }
        }
        this.close();
    }

    private resetForm(): void {
        this.riskMatrix = {
            id: undefined,
            riskRating: '',
            dateOfReview: null,
            reviewFrequency: '',
            nextReviewDate: null,
            individualRiskRating: '',
            institutionRiskMatrix: '',
            complianceRiskmatrixName: '',
            riskProfileLocal: '',
            riskProfileInternational: '',
            comments: '',
            pep: '',
            pepStatus: '',
            startDate: null,
            endDate: null,
            dateCreated: null,
            dateModified: null,
            createdBy: '',
            modifiedBy: ''
        };
    }
}

export const RiskMatrixPanelComponent: angular.IComponentOptions = {
    template: require('./risk-matrix-panel.html'),
    controller: RiskMatrixPanelController,
    controllerAs: '$ctrl',
    bindings: {
        onSave: '&',
        onClose: '&',
        onDelete: '&'
    }
};



// WEBPACK FOOTER //
// ./src/app/clients/clients.details/compliance/modals/tabs/risk-matrix/risk-matrix-panel.ts